const gradek = require('./gradek.json')
const grade1 = require('./grade1.json')
const grade2 = require('./grade2.json')
const grade3 = require('./grade3.json')
const grade4 = require('./grade4.json')
const grade5 = require('./grade5.json')
const grade6 = require('./grade6.json')
const grade7 = require('./grade7.json')
const grade8 = require('./grade8.json')

const tasks = [];

gradek.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 0;
  modifiedTask.data = task;

  tasks.push(modifiedTask);
})

grade1.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 1;
  modifiedTask.data = task;

  tasks.push(modifiedTask);
})

grade2.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 2;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

grade3.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 3;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

grade4.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 4;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

grade5.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 5;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

grade6.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 6;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

grade7.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 7;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

grade8.forEach((task) => {
  let modifiedTask = {};
  modifiedTask.grade = 8;
  modifiedTask.data = task;
  
  tasks.push(modifiedTask);
})

export default tasks;
